import { useCompanyCredits } from './useCompanyCredits';
import { useUserCredits } from './useUserCredits';

export function useDualCredits() {
  const { wallet, loading: companyLoading, companyId } = useCompanyCredits();
  const { balance: userBalance, loading: userLoading } = useUserCredits();

  const companyBalance = wallet?.balance ?? 0;
  const totalAvailable = companyBalance + userBalance;
  const loading = companyLoading || userLoading;

  return { companyBalance, userBalance, totalAvailable, companyId, loading };
}
